import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Empleos from "../../components/carrusel/UserEmpleosDestacados";
import "./css/Empleo.css";

const Empleo = () => {

  const navigate = useNavigate();
  const [categoria, setCategoria] = useState("destacadas");
  
  return (
    <>
        <Navbar />
        
        <main className="main-user empleo-formacion">
          <section className="between cabecera">
            <h1 className="titulo-user align-center">
              <span className="titulo-user align-center gap-10">
                OFERTAS DE EMPLEO
                <select
                  aria-label="Filtradas por"
                  className="desplegable-empleo mayusculas" 
                  value={categoria} 
                  onChange={(e) => setCategoria(e.target.value)}
                >
                  <option value="destacadas">destacadas</option>
                  <option value="isla">en Isla Cristina</option>
                  <option value="todos">TODAS</option>
                </select>
              </span>
            </h1>
            <button className="boton-modal boton" onClick={() => navigate("/recursos", { state: { categoria: "empleo" } })}>Recursos</button>
          </section>

          <Empleos categoria={categoria} />

        </main>

    </>
  );
};

export default Empleo;